export const navigation = [
  {
    icon: 'menu'
  },
  {
    text: 'Statement Center',
    path: '/statements',
    icon: 'statement-center',
  },
  {
    text: 'Audit Center',
    path: '/audit-center',
    icon: 'shield',
  },
  {
    text: 'ERP Integration',
    path: '/erp-integration',
    icon: 'link',
  },
  {
    text: 'Import AP Transactions',
    path: '/import-ap-transactions',
    icon: 'upload',
  },
  {
    text: 'Email Settings',
    path: '/email-setting',
    icon: 'email',
  }
];
